import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import { ShowMoreButton } from "../../../../../../CommonComponents/CTA/Buttons";
import {
  ContentDivider,
  LinkWrapper,
  ExpandableLabel,
  AlertWrap,
  TableEditBtnWrapper
} from "../../style";
import { CancelAlert } from "../../../../../../CommonComponents/CancelPopup/CancelPopUp";
import {
  AlertContent,
  Types,
} from "../../../../../../CommonComponents/ContentMessages";
import {
  LabelDataHead,
  ValueDataHeading,
  LinkHeading,
} from "../RenderCard/style";
import formatter from "../../../../../../utils/formatter";
import { spawnAccessCheck, isAllocationValuePercent } from "../../utils";
import { recordError } from "../../../../../../utils/commonUtil";
import { CapsuleButton } from '../../../../../../CommonComponents/Commons/commonComponents';
import { replaceSelect } from "../../../../../../utils/replacer"

const WarningContents = {
  allSpawns: "Are you sure you want to cancel all remaining payments?",
  spawn: "Are you sure you want to cancel this grant payments?",
};

export const showMoreRender = (data) => (
  <div>
    <div className="flex justify-between">
      <ExpandableLabel header>Investment Options</ExpandableLabel>
      <ExpandableLabel header>
        {isAllocationValuePercent(data.allocationType)
          ? "Grant Percentage"
          : "Grant Amount"}
      </ExpandableLabel>
    </div>
    {data.grantAllocation ? (
      data.grantAllocation.map((item) => (
        <div className="flex justify-between" key={item.poolId}>
          <ExpandableLabel>{replaceSelect(item.option)}</ExpandableLabel>
          <ExpandableLabel>
            {isAllocationValuePercent(data.allocationType)
              ? `${formatter({
                  value: item.value,
                  fieldSuffix: "Percentage",
                })}`
              : `${formatter({ value: item.value, fieldSuffix: "Dollars" })}`}
          </ExpandableLabel>
        </div>
      ))
    ) : (
      <div>No Investment</div>
    )}
  </div>
);

export const showMoreConditionRender = ({
  status,
  edit,
  showMoreFlag,
  showMoreChange,
}) => (
  <>
    <Col span={24}>
      {spawnAccessCheck(status) && edit ? (
        <Row>
          <ShowMoreButton
            reverse={showMoreFlag}
            buttonHandle={showMoreChange}
          />
          <ContentDivider />
        </Row>
      ) : (
        ""
      )}
    </Col>
  </>
);

export const viewRender = ({
  spawn,
  edit,
  scheduleStatus,
  individualCancelHandler,
  showMoreFlag,
  showMoreChange,
  contentType,
  cancelPopUp,
  cancelHandler,
  viewHandle
}) => (
  <>
    <>
      <CancelAlert
        title={
          <AlertContent
            page={"Edit Grant"}
            type={[Types.PAGE_ALERTS]}
            keyProperty={
              contentType === "allSpawns"
                ? "Cancel All Payment Edit Grant"
                : "Cancel Payment Edit Grant"
            }
            property={"field_header"}
            html={true}
            defaultMessage={"Cancel"}
          />
        }
        visible={cancelPopUp}
        onOk={cancelHandler}
        onCancel={() => individualCancelHandler()}
        cancelText={
          <AlertContent
            page={"Edit Grant"}
            type={[Types.PAGE_ALERTS]}
            keyProperty={
              contentType === "allSpawns"
                ? "Cancel All Payment Edit Grant"
                : "Cancel Payment Edit Grant"
            }
            property={"field_alert_button2_text"}
            html={true}
            defaultMessage={"No, take me back"}
          />
        }
        okText={
          <AlertContent
            page={"Edit Grant"}
            type={[Types.PAGE_ALERTS]}
            keyProperty={
              contentType === "allSpawns"
                ? "Cancel All Payment Edit Grant"
                : "Cancel Payment Edit Grant"
            }
            property={"field_alert_button1_text"}
            html={true}
            defaultMessage={"CONTINUE"}
          />
        }
      >
        <AlertWrap>
          <AlertContent
            page={"Edit Grant"}
            type={[Types.PAGE_ALERTS]}
            keyProperty={
              contentType === "allSpawns"
                ? "Cancel All Payment Edit Grant"
                : "Cancel Payment Edit Grant"
            }
            property={"field_description"}
            html={true}
            defaultMessage={WarningContents[contentType]}
          />
        </AlertWrap>
      </CancelAlert>
    </>
    <Col span={12}>
      <ValueDataHeading>
        {edit &&
        scheduleStatus === "Active" &&
        spawnAccessCheck(spawn.status) ? (
          <TableEditBtnWrapper>
            <CapsuleButton
              text="View & Edit"
              onClick={() => viewHandle({ spawnId: spawn.spawnId, edit: true })}
              whiteBackground={true}
              alt = "view and edit"
            />
          </TableEditBtnWrapper>
        ) : (
          <TableEditBtnWrapper>
            <CapsuleButton
              text="View"
              onClick={() => viewHandle({ spawnId: spawn.spawnId, edit: false })}
              whiteBackground={true} alt  = "view button"
            />
          </TableEditBtnWrapper>
        )}
      </ValueDataHeading>
    </Col>
    <Col span={12}>
      {spawnAccessCheck(spawn.status) && edit ? (
        <LinkWrapper onClick={() => individualCancelHandler(spawn, "spawn")}>
          Cancel
        </LinkWrapper>
      ) : (
        <ShowMoreButton reverse={showMoreFlag} buttonHandle={showMoreChange} />
      )}
    </Col>
  </>
);

const RecurringCard = (props) => {
  const [showMoreFlag, showMoreHandle] = useState(false);
  const { data, indexKey, viewHandle, cancelApi, scheduleStatus, edit } = props;
  const [_currentSpawnId, setCurrentSpawn] = useState(false);
  const [contentType, setPopUpContent] = useState(false);
  const [cancelPopUp, setCancelPopup] = useState(false);

  useEffect(() => {}, [data]);

  const individualCancelHandler = (record, type) => {
    try {
      if (record) {
        let _spawnId = record && record.spawnId;
        setCurrentSpawn(_spawnId);
      }
      if (type) {
        setPopUpContent(type);
      } else {
        setCurrentSpawn(false);
        setPopUpContent("allSpawns");
      }
  
      setCancelPopup(!cancelPopUp);
    } catch (error) {
      recordError(error);
    }
  };

  const showMoreChange = useCallback(() => {
    showMoreHandle(!showMoreFlag);
  },[showMoreFlag]);

  const cancelHandler = () => {
    setCancelPopup(false);
    _currentSpawnId
      ? cancelApi(_currentSpawnId, "single")
      : cancelApi(_currentSpawnId, "all");
  };

  return (
    <div>
      <Row>
        <Col span={24}>
          <LinkHeading>{data.grantName}</LinkHeading>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <LabelDataHead>Grant Amount</LabelDataHead>
          <ValueDataHeading>
            {data.amount ? (
              formatter({ value: data.amount, fieldSuffix: "Dollars" })
            ) : (
              <div>&mdash;</div>
            )}
          </ValueDataHeading>
        </Col>
        <Col span={12}>
          <LabelDataHead>Scheduled Issue Date</LabelDataHead>
          <ValueDataHeading>
            {data.scheduledDate ? data.scheduledDate : <div>&mdash;</div>}
          </ValueDataHeading>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={12}>
          <LabelDataHead>Issue Date</LabelDataHead>
          <ValueDataHeading>
            {data.issueDate ? data.issueDate : <div>&mdash;</div>}
          </ValueDataHeading>
        </Col>
        <Col span={12}>
          <LabelDataHead>Check Number</LabelDataHead>
          <ValueDataHeading>
            {data.checkNumber ? data.checkNumber : <div>&mdash;</div>}
          </ValueDataHeading>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={24}>
          <LabelDataHead>Status</LabelDataHead>
          <ValueDataHeading>
            {data.status ? data.status : <div>&mdash;</div>}
          </ValueDataHeading>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        {viewRender({
          spawn: data,
          edit,
          scheduleStatus,
          individualCancelHandler,
          showMoreFlag,
          showMoreChange,
          contentType,
          cancelPopUp,
          cancelHandler,
          viewHandle
        })}
      </Row>
      <ContentDivider />
      <Row>
        {showMoreConditionRender({
          status: data.status,
          edit: edit,
          showMoreFlag: showMoreFlag,
          showMoreChange: showMoreChange,
        })}
      </Row>
      {showMoreFlag && <Row>{showMoreRender(data)}</Row>}
      {showMoreFlag && <ContentDivider />}
    </div>
  );
};

RecurringCard.propTypes = {
  data: PropTypes.shape({
    allocationType: PropTypes.string,
    amount: PropTypes.string,
    checkNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    grantAllocation: PropTypes.arrayOf(
      PropTypes.shape({
        allShareSpecificPool: PropTypes.bool,
        option: PropTypes.string,
        poolId: PropTypes.number,
        value: PropTypes.string,
      })
    ),
    grantName: PropTypes.string,
    issueDate: PropTypes.string,
    scheduledDate: PropTypes.string,
    spawnId: PropTypes.number,
    status: PropTypes.string,
  }),
  indexKey: PropTypes.bool,
  viewHandle: PropTypes.func,
  cancelApi: PropTypes.func,
  scheduleStatus: PropTypes.string,
  edit: PropTypes.bool,
};

export default RecurringCard;
